import UtilityStrokeInfoOutlineSmallIcon from '@mweb/zappos-ui/Icons/UtilityStrokeInfoOutlineSmallIcon';

import InfoOutlineSmallIcon from 'components/common/IconsV2/InfoOutlineSmallIcon';
import type { PerformanceAttribute } from 'types/cloudCatalog';
import { SUPPORT_ATTRIBUTE, WEIGHT_ATTRIBUTE } from 'constants/product';
import { TechSpecsTooltip } from 'components/productdetail/accordions/TechSpecsTooltip';
import { cn } from 'helpers/classnames';

interface TechSpecsTitleProps {
  attribute: PerformanceAttribute;
  isMobile?: boolean;
  text: string;
}

export const TechSpecsTitle = ({ attribute, isMobile, text }: TechSpecsTitleProps) => {
  if (attribute.attributeId === WEIGHT_ATTRIBUTE && attribute.value.includes('-')) {
    // has weight range
    return (
      <TechSpecsTooltip text={text} testId="weightSpecTitle">
        Weight changes based on size
      </TechSpecsTooltip>
    );
  }

  if (attribute.attributeId === SUPPORT_ATTRIBUTE) {
    return (
      <div className="flex items-center gap-x-1 text-base" data-test-id="supportSpecTitle">
        <span className={cn('whitespace-nowrap text-left text-xs', 'lumon:body-xs', { 'text-sm': isMobile })}>{text}</span>
        <>
          <UtilityStrokeInfoOutlineSmallIcon className="h-3 w-3 lumon:hidden" size={16} />
          <InfoOutlineSmallIcon className="size-3 not-lumon:hidden" size={16} />
        </>
      </div>
    );
  }

  return (
    <div className={cn('text-left text-xs', 'lumon:body-xs', { 'text-sm': isMobile })} data-test-id="techSpecsTitle">
      {text}
    </div>
  );
};
